import { useCallback, useMemo } from 'react';
import cls from 'classnames';
import styles from './index.module.scss';
export default (props: Record<string, any>) => {
  const { brands = [] } = props;
  const gotoLink = useCallback((item: any) => {
    console.log('gotoLink===', item);
    if (item?.redirectUrl) {
      window.open(item?.redirectUrlH5 || item?.redirectUrl);
    }
  }, []);
  const brandArra = useMemo(() => {
    const brandNodes: Array<any> = [];
    let childrens: Array<any> = [];
    brands.forEach((item: any, index: number) => {
      childrens.push(
        <div
          className={
            (index + 1) % 4 == 0
              ? cls('flex1', 'flex', 'v-center', styles['brand-cell'])
              : cls('flex1', 'flex', styles['left-border'], 'v-center', styles['brand-cell'])
          }
          key={index}
        >
          <div onClick={() => gotoLink(item)} className={cls(styles['inner-cell'], 'flex', 'v-center', 'h-center')}>
            <img src={item.url} />
          </div>
        </div>
      );
      if ((index + 1) % 4 == 0 || index === brands.length - 1) {
        if (childrens.length) {
          brandNodes.push(
            <div key={index} className={cls(styles['brand-row'], 'flex')}>
              {childrens}
            </div>
          );
        }
        childrens = [];
      }
    });
    return brandNodes;
  }, [brands]);
  return (
    <div className={cls(styles['bands-content'], 'mt30', 'p16')}>
      <div className={styles['sub-title']}>品牌专区</div>
      <div className={styles['brands-main']}>{brandArra}</div>
    </div>
  );
};
